import { useState, useCallback } from "react";
import { Toast } from '@douyinfe/semi-ui';

import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import useRequest from "@/utils/useRequest";

import styles from "./styles.module.scss";
import cName from "classnames";

export default ({ }) => {
  const router = useRouter()
  const t = useTranslations();

  const request = useRequest()
  const [formData, setFormData] = useState({
    company: '',
    truename: '',
    email: '',
  })

  const onChage = useCallback((e: any, type: 'company' | 'truename' | 'email') => {
    const data = { ...formData }
    data[type] = e.target.value
    setFormData(data)
  }, [formData])

  const subscribe = useCallback(async () => {
    if (!formData.company || !formData.truename || !formData.email) {
      Toast.error({
        content: t('common.tips.all'),
        duration: 3,
      })
      return
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(formData.email)) {
      Toast.error({
        content: t('common.tips.email'),
        duration: 3,
      })
      return
    }
    const { data } = await request.post('/addSubscribe', {
      company: formData.company,
      truename: formData.truename,
      email: formData.email,
    })
    if (data.code === 200) {
      Toast.success({
        content: data?.msg,
        duration: 3,
      })
    } else {
      Toast.error({
        content: data?.msg,
        duration: 3,
      })
    }

    if (data?.code) {
      setFormData({
        company: '',
        truename: '',
        email: '',
      })
    }

  }, [formData])

  return (
    <footer className={styles.footer}>
      <div className={styles.subscribe}>
        <i className={styles.icon}><img src="/image/subscribe-icon.png" alt="" /></i>
        <p className={styles.tips}>
          {t('common.subscribe1')}
          <br />
          {t('common.getNew')}
        </p>
        <div className={styles.form}>
          <input className={styles.input} type="text" placeholder={t('common.placeholder.company')} value={formData.company}
            onChange={(e) => onChage(e, 'company')} />
          <i className={styles.line}></i>
          <input className={styles.input} type="text" placeholder={t('common.placeholder.name')} value={formData.truename}
            onChange={(e) => onChage(e, 'truename')} />
          <i className={styles.line}></i>
          <input className={styles.input} type="text" placeholder={t('common.placeholder.email')} value={formData.email}
            onChange={(e) => onChage(e, 'email')} />
          <button className={styles.button} onClick={subscribe}>{t('common.subscribe')}</button>
        </div>
      </div>
      <div className={styles.info}>
        <div className={cName(styles.top, 'm-1480')}>
          <img className={styles.logo} src="/image/footer-logo.png" alt="" />
          <div className={styles.content}>
            <div className={styles.left}>
              <p className={styles.time}>{t('common.time')}</p>
              <p className={styles.site}>{t('common.site')}{router.locale === 'en' && <br />}{t('common.location')}</p>
            </div>
            <div className={styles.middle}>
              <p className={styles.unit}>{t('common.organizers')}：{t('common.organizer1')}</p>
              <p className={styles.phone}>{t('common.telephone')}：{router.locale === 'en' ? '+86 ' : ''}021-6036-5871</p>
              <p className={styles.email}>{t('common.email')}：ipb@nm-china.com.cn</p>
              <p className={styles.address}>{t('common.companySite')}：{t('common.companySite1')}</p>
            </div>
            <div className={styles.middle}>
              <p className={styles.unit}>{t('common.organizers')}：{t('common.organizer2')}</p>
              <p className={styles.phone}>{t('common.telephone')}：010-62647647/62647657</p>
              <p className={styles.email}>{t('common.email')}：klxh@ipe.ac.cn</p>
              <p className={styles.address}>{t('common.companySite')}：{t('common.companySite2')}</p>
            </div>
            <div className={styles.right}>
              <p className={styles.follow}>{t('common.attention')}</p>
              {
                router.locale === 'en'
                  ?
                  <div className={styles.icons}>
                    <a href="https://www.linkedin.com/company/ipb-%E2%80%93-international-processing-trade-fair-for-powder-bulk-solids-and-fluids" target="_blank">
                      <img src="/image/linkedin.png" alt="linkedin" />
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61570741266909" target="_blank">
                      <img src="/image/facebook.png" alt="facebook" />
                    </a>
                  </div>
                  :
                  <div className={styles.list}>
                    <div className={styles.item}>
                      <img src="/image/wxcode.png" alt="" />
                      <p>{t('common.wxOfficial')}</p>
                    </div>
                    <div className={styles.item}>
                      <img src="/image/video-code.png" alt="" />
                      <p>{t('common.wxVideo')}</p>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
        <div className={cName(styles.bottom, 'm-1480')}>
          <p>
            {t('common.organizers')}
            <img src="/image/sponsor1.png" alt="" />
            <img src="/image/sponsor2.png" alt="" />
          </p>
          <p>
            {t('common.powered')}
            <img src="/image/sponsor3.png" alt="" />
          </p>
          <p>
            {t('common.supported1')}
            <img src="/image/sponsor4.png" alt="" />
          </p>
        </div>
      </div>
      <div className={styles.copyright}>
        <a className={styles.privacy} href={`${router.locale === 'en' ? '/en' : ''}/privacypolicy`} target="_blank">{t('common.privacy')}</a>
        <p>{t('common.copyright')}<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"> © 2026 沪ICP备09011147号-16</a></p>
      </div>
    </footer>
  );
};
